<ion-icon *ngIf="isSuccess" [style.color]="color" name="mail"></ion-icon>

<div *ngIf="!isSuccess" class="popup-message">
  <h2 [style.color]="color">
    {{ 'ERROR' | translate }}
  </h2>
</div>

<div class="popup-message">
  <h4 [style.color]="color">
    {{ message | translate }}
  </h4>
</div>

<div class="popup-footer" [style.backgroundColor]="color">
  <ion-button
    expand="full"
    size="large"
    strong="true"
    fill="clear"
    color="light"
    (click)="validated.emit(true)"
  >
    {{ buttonLabel | translate }}
  </ion-button>
</div>
